import React from 'react';
import styled from 'styled-components';
import LandingSectionHeader from '../../Components/LandingSectionHeader';

const FeatureList = [
  {
    name: '專業快速',
    icon: '/images/home-clock-icon.png',
    desp:
      '專項分工，每一個製作過程都有專業的人員執行，讓每一個關卡都以最有效率的方式進行',
  },
  {
    name: '有效溝通',
    icon: '/images/home-message-icon.png',
    desp:
      '我們提供專業客服以及專業的印刷人員，在線為您解決製作上所遇到的困難，使溝通更加有效。',
  },
  {
    name: '精美客製',
    icon: '/images/home-response-icon.png',
    desp:
      'Pinbar拼吧使用高規格的十色印刷，讓您的作品細節更加精美，這樣的品質的把關也是我們所追求的。',
  },
  {
    name: '線上編輯',
    icon: '/images/home-group-icon.png',
    desp:
      '線上上傳您喜愛的影像，直覺的操作方式，即時模擬初完成後的實品，給您最快速便捷的體驗。',
  },
];

function Features() {
  return (
    <Wrapper>
      <LandingSectionHeader title="Pinbar 特色" subtitle="Service Features" />
      <section>
        {FeatureList.map((data, i) => (
          <FeatureItem data={data} key={i} />
        ))}
      </section>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 95px 45px;
  background-color: var(--primaryColor);
  & > section {
    display: flex;
    align-items: flex-start;
    justify-content: space-around;
    flex-wrap: wrap;
  }
`;

export default Features;

function FeatureItem(props) {
  const {data} = props;
  return (
    <ItemWrapper>
      <h3>{data.name}</h3>
      <img src={data.icon} alt="not found" />
      <p>{data.desp}</p>
    </ItemWrapper>
  );
}

const ItemWrapper = styled.div`
  width: 200px;
  min-height: 380px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  & > h3 {
    width: 100%;
    border-bottom: 1px solid #ffffff;
    padding-bottom: 25px;
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    color: #ffffff;
  }

  & > img {
    margin: 45px 0px;
    width: 100px;
    height: 100px;
  }

  & > p {
    text-align: center;
    line-height: 1.93;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
  }

  @media screen and (max-width: 1023px) {
    width: 40vw;
  }

  @media screen and (max-width: 575px) {
    width: 90vw;
  }
`;
